import { t } from "../../../../services";
import { strCode } from "../../../../consts";

import { Paragraph2, WrapperContainer } from "../../../../components";

const RevokeConfirmationStep = () => {
  return (
    <WrapperContainer maxWidth={384}>
      <Paragraph2>{t(strCode.REVOKE_WARNING_MSG)}</Paragraph2>
    </WrapperContainer>
  );
};

export default RevokeConfirmationStep;
